<template>
  <Modal :open="open" @close="close">
    <div>
      <p class="text-center text-gray-600 mb-6">Êtes-vous sûr de vouloir annuler ce dossier sinistre ?</p>

      <div class="mb-6">
        <Textarea
          id="customerMessage"
          v-model="customerMessage"
          label="Notes du gestionnaire"
          label-class="block text-sm font-medium leading-6 text-gray-900"
          :required="true"
          placeholder="Veuillez indiquer le motif de l'annulation..."
        />
      </div>

      <div class="flex justify-center space-x-4">
        <SecondaryButton
          @click="handleCancelClaim"
          :disabled="!customerMessage || customerMessage.trim() === ''"
          class="disabled:cursor-not-allowed"
        >
          Confirmer l'annulation
        </SecondaryButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, SecondaryButton, Textarea } from "@estaly/ui";
import { mapActions } from "vuex";

export default {
  components: {
    Modal,
    SecondaryButton,
    Textarea,
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      customerMessage: "",
    };
  },

  methods: {
    ...mapActions("claims", ["cancelClaim"]),
    ...mapActions("notifications", ["notify"]),

    async handleCancelClaim() {
      const response = await this.cancelClaim({ customerMessage: this.customerMessage.trim() });

      if (!response?.success) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Dossier sinistre annulé avec succès",
      });
      this.close();
    },

    close() {
      this.customerMessage = "";
      this.$emit("close");
    },
  },

  watch: {
    open(newVal) {
      if (newVal) {
        this.customerMessage = "";
      }
    },
  },
};
</script>
